import React, { useEffect } from "react";
import Layout from "../../Layout";
import HeaderUser from "../HeaderUser";
import FormUserUpload from "./FormUserUpload";

const UploadUser = () => {
    useEffect(() => {
        const title = document.querySelector("h1.form-title");
        if (title) {
            title.setAttribute("tabindex", "-1");
            title.focus();
        }
    }, []);

    return (
        <Layout>
            <HeaderUser />
            <main className="layout-container">
                <div
                    className="container"
                    tabIndex="-1"
                >
                    <h1 className="form-title g-clr">Upload Users</h1>
                    <div className="descript-container" id="uploadUsersDesc">
                        <p>The data in the CSV file prepared for upload must not contain any
                    commas, as CSV format uses commas as field separators. Any comma
                    within a field will disrupt the formatting. The first line in the file
                    is a fixed header containing field names, as shown in the screenshot
                    of the sample file below. This header line is also included in the CSV
                    template. Please ensure you save your upload file in CSV
                    (comma-separated values) format.</p>
                </div>
                <FormUserUpload />
            </div>
        </main>
        </Layout>
    )
};

export default UploadUser;
